import { getInitializeIntl, getUseIntl } from "@akina/presentation";

export const useInitializeIntl = getInitializeIntl.care;
export const useIntl = getUseIntl.care;
